/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { SolutionSegmentTrackingViewModel } from '../solution-segment-tracking-view.model';
import { MasterRoutingSolutionState } from './master-routing-solution-state.model';

export class MasterRoutingSolutionTrackingViewModel extends JSONable {
  uuid: string | undefined = undefined;
  lockedInShipmentGroupUuid: string | undefined = undefined;
  solutionSegmentTrackingViewSet: SolutionSegmentTrackingViewModel[] | undefined = undefined;
  shipmentGroupSolutionUuid: string | undefined = undefined;
  shipmentGroupUuid: string | undefined = undefined;
  spOrderUuid: string | undefined = undefined;
  orderUuid: string | undefined = undefined;
  spOfferRequestUuid: string | undefined = undefined;
  offerRequestUuid: string | undefined = undefined;
  preferred: boolean | undefined = undefined;
  createdAt: string | undefined = undefined;
  permitsOffers: boolean | undefined = undefined;
  state: MasterRoutingSolutionState | undefined = undefined;
}
